import { defineComponent } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import SmeSupportForm from "../../components/SmeSupportForm";

export default defineComponent({
    components: {
        SmeLayout,
        SmeSupportForm,
    },

    template: `
        <SmeLayout class="StepSmeOtherTariff">
            <div class="SmeSupportFormBox contentbox contentbox--white">
                <h1 class="title-2">Twoja firma zasługuje na coś wyjątkowego!</h1>

                <SmeSupportForm type="othertariff">
                    <p class="SmeSupportFormBox__text">Niestety dla Twojej taryfy nie posiadamy oferty online. Wypełnij formularz, a nasz Doradca przygotuje ofertę dopasowaną do potrzeb Twojej firmy.</p>
                </SmeSupportForm>
            </div>
        </SmeLayout>
    `,

    emits: [
        'offers'
    ],

    props: {
    },

    setup(props, ctx) {
        return {
        };
    },
});
